import React, { useState } from 'react'
import cn from 'classnames'
import DialogsList from './components/DialogsList/DialogsList'
import MessagesList from './components/MessagesList/MessagesList'

function SupportQuestion() {
  const [selectedDialog, setSelectedDialog] = useState(null)
  console.log("🚀 ~ file: index.jsx ~ line 7 ~ SupportQuestion ~ selectedDialog", selectedDialog)
  return (
    <div className={cn([
      "support-wrapper",
      "support-wrapper--flex-full-x-y",
      "flex-1",
      //"support-wrapper--indend-bottom",
      "support-wrapper--height",
  ])} style={{height: 'calc(100vh - 210px)'}}>
      <div className="support-wrapper__col support-wrapper__col--height support-wrapper__col--regulator support-wrapper__col--ovh-auto">
          <DialogsList 
            setSelectedDialog={(id) => setSelectedDialog(id)}
            selectedDialog={selectedDialog}
          />
      </div>
      <div className="support-wrapper__col support-wrapper__col--default support-wrapper__col--height support-wrapper__col--flex-grow">
          <MessagesList selectedDialog={selectedDialog} />
      </div>
  </div>
  )
}

export default SupportQuestion


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/SupportQuestion/index.jsx